import React, {useContext} from 'react';

import NavigationSubcategory from '~/src/components/navigation/subcategory/NavigationSubcategory';
import Link from '~/src/components/link/Link';
import Boomerang from '~/src/components/svg/general/Boomerang';
import {SectionProps} from '~/src/components/teaser/section/TeaserSection';

import {SettingsContext} from '~/src/components/context/SettingsContext';
import {SectionLayout} from '~/src/utilities/constants/layout';
import {classNames} from '~/src/utilities/helpers/css';
import {getCategoryUrl} from '~/src/utilities/helpers/link';
import {createNavigationTracker} from '~/src/utilities/tracking/gtm';

import css from './TeaserLayoutDefault.module.scss';

export interface TeaserLayoutProps extends SectionProps {
    colorScheme?: string;
    children: React.ReactElement[];
}

const TeaserLayoutDefault = ({children, layout, title, fullUrlPath, showTitle, colorScheme, pointerCategoryID}: TeaserLayoutProps) => {
    const {siteArea} = useContext(SettingsContext);
    const headerClassNames = classNames(css, 'titleHeader', layout, siteArea, colorScheme);
    const teaserClassNames = classNames(css, 'teasers', siteArea, colorScheme);

    return (
        <React.Fragment>
            {showTitle && (
                <div className={headerClassNames}>
                    <h1 className={css.title}>
                        {fullUrlPath ? (
                            <Link
                                className={css.titleLink}
                                href={getCategoryUrl(fullUrlPath)}
                                onClick={pointerCategoryID ? createNavigationTracker(4, title, pointerCategoryID) : null}
                            >
                                {title}
                                <Boomerang />
                            </Link>
                        ) : (
                            title
                        )}
                    </h1>

                    {layout === SectionLayout.SUB_NAVIGATION && pointerCategoryID && (
                        <NavigationSubcategory categoryId={pointerCategoryID} inTeaserSection={true} />
                    )}
                </div>
            )}
            <div className={teaserClassNames}>{children}</div>
        </React.Fragment>
    );
};

export default TeaserLayoutDefault;
